class CheckSwitch {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._elem = elem
        this._key = elem.dataset.checkSwitch
        this._check = document.querySelector(`[data-check="${this._key}"]`)
        this._errorElem = document.querySelector('[data-check-switch-failed]')
    }

    onInit () {
        this._elem.addEventListener('click', e => {
            if (!this._check.checked) {
                this._errorElem.classList.remove('visually-hidden')
                e.preventDefault()
                return false
            }
        })
    }
}

export default CheckSwitch



// WEBPACK FOOTER //
// ./src/scripts/components/CheckSwitch.js